/* -------------------------------------------------------------------------- *
 * Window Width *
 * -------------------------------------------------------------------------- *
 */

const settings = {
    selector: '.agenda__toggle',
};

const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
const toggle1 = document.getElementById('js-Day 1Toggle');
const toggle2 = document.getElementById('js-Day 2Toggle');
const speakers = document.getElementById('js-speakersToggle');

/* ------------- *
 * Module Export *
 * ------------- */

const WindowWidth = {
    selector: settings.selector,

    init() {
        if (viewportWidth < 500) {
            toggle1.classList.remove('is-active');
            toggle2.classList.remove('is-active');
            speakers.classList.remove('is-active');
        }
    },
};

export default WindowWidth;
